import React, { Component } from 'react';
import axios from 'axios';

import TopMenuItem from './TopMenuItem';

import './stylesheet/styles.scss';

const localStorageSupport = window.localStorage;
let localStorageItemExist = false;

if (localStorageSupport) {
  try {
    localStorageItemExist =
      window.localStorage.getItem('topMenuPrioritized') !== null;
  } catch (err) {
    // Do nothing
  }
}

const bodyOriginalClasses = window.is_it_black_week
  ? `${document.body.className} black_friday`
  : document.body.className;

export default class TopMenu extends Component {
  constructor(props) {
    super(props);
    let items = [];
    if (localStorageSupport) {
      // If supported and the menu data is in storage, no need to wait for fetch to finish
      if (localStorageItemExist) {
        try {
          items = JSON.parse(window.localStorage.getItem('topMenuPrioritized'));
        } catch (err) {
          // Do nothing
        }
      }
    }
    this.state = {
      items,
      openElement: null,
      initState: false
    };
    this.updateItems = this.updateItems.bind(this);
  }

  componentDidMount() {
    if (!this.state.initState) {
      if (window.Promise) {
        window
          .fetch(this.props.menuAPIURL)
          .then(response => response.json())
          .then(json => {
            const type = Object.keys(json)[0];
            this.updateItems(json[type]);
          });
      } else {
        axios
          .get(this.props.menuAPIURL)
          .then(data => {
            const type = Object.keys(data.props)[0];
            this.updateItems(data.props[type]);
          })
          .catch(() => {
            // Handle errors
          });
      }
    } else if (window)
      this.updateItems(window.__INITIAL_NAVIGATION_STATE__.top);
  }

  setTopDropdown(id) {
    /**
     * f.ex. id can be overlay-<id> or topmenuUni or topmenuCS
     */
    const elem = document.getElementById(id);
    const tiny_banner = document.getElementById('tiny_banner');
    if (elem && tiny_banner) {
      elem.style.marginTop = `${tiny_banner.offsetHeight}px`;
      return 1;
    }
    return 0;
  }

  handleItemClicks = (el, itemId) => {
    if (el !== null) {
      this.setState(
        {
          openElement: el
        },
        () => {
          this.props.handleOverLay('TopMenu', true, itemId);
          if (document.body.className.indexOf('bodyLocked') < 0) {
            document.body.className += ' bodyLocked';
          }
        }
      );
    } else {
      this.props.handleOverLay(null, false);
      document.body.className = bodyOriginalClasses;
    }
  };

  updateItems(data) {
    if (!localStorageSupport || !localStorageItemExist) {
      this.setState({ items: data });
    }
    this.storeItems('topMenuPrioritized', data);
  }

  storeItems(tagName, data) {
    if (localStorageSupport) {
      window.localStorage.setItem(tagName, JSON.stringify(data));
    }
  }

  render() {
    return (
      <div id="top-menu-nav" className="nav">
        {this.state.items && this.state.items.length > 0 && (
          <ul className="dynamic-top-nav navbar" data-testid="top-nav">
            {this.state.items
              .filter(item => item.online)
              .map((item, index) => (
                <TopMenuItem
                  index={index}
                  isOpen={
                    index === this.state.openElement && this.props.isItemActive
                  }
                  key={item.base_item_id}
                  id={item.base_item_id}
                  title={item.title}
                  slug={item.slug}
                  subMenu={item.items}
                  subtitle={item.subtitle}
                  handleItemClicks={el =>
                    this.handleItemClicks(el, item.base_item_id)
                  }
                  setTopMargin={this.setTopDropdown}
                />
              ))}
          </ul>
        )}
      </div>
    );
  }
}
